import { classNamesFunction } from '@fluentui/react';
import * as React from 'react';
import { gethorizontalBarChartStyles } from './horizontal-bar-chart-loading-animation.styles';
const getClassNames = classNamesFunction();
// tslint:disable-next-line:max-line-length // we shouldn't let linters/prettier dictate our variable names
export const HorizontalBarChartLoadingAnimationBase = (props) => {
    const classNames = getClassNames(gethorizontalBarChartStyles, { theme: props.theme });
    return (React.createElement("div", { className: classNames.root },
        React.createElement("div", { className: classNames.loadingBar },
            React.createElement("div", { className: classNames.firstSegment }),
            React.createElement("div", { className: classNames.secondSegment }))));
};
//# sourceMappingURL=horizontal-bar-chart-loading-animation.base.js.map